import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  MessageRow,
  StyledMessage,
  StyledMessageContent,
  MessageTimeStamp,
  MessageDisplayName,
  MessageBody,
  NoDataFound,
} from "styles/components/order-card";

const OrderComments = ({ comments }) =>
  comments?.length > 0 ? (
    comments?.map((c) => (
      <MessageRow key={c?.timeStamp}>
        <Avatar
          alt={c?.name}
          src={c?.profileImg}
          sx={{ border: "1px solid #ccc", marginRight: "10px" }}
        />

        <MessageBody>
          <MessageDisplayName>{c?.name}</MessageDisplayName>
          <StyledMessage>
            <div>
              <StyledMessageContent>{c?.stockStatus}</StyledMessageContent>

              {/* Line Items Table */}
              {c?.lineItems && c?.lineItems.length > 0 && (
                <div style={{ marginTop: "12px" }}>
                  <TableContainer
                    component={Paper}
                    elevation={1}
                    sx={{ maxWidth: "100%" }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ fontWeight: "bold", fontSize: "12px" }}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", fontSize: "12px" }}
                          >
                            Qty
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", fontSize: "12px" }}
                          >
                            Received
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {c.lineItems.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ fontSize: "12px" }}>
                              {item.description || "N/A"}
                            </TableCell>
                            <TableCell style={{ fontSize: "12px" }}>
                              {item.qty || 0}
                            </TableCell>
                            <TableCell style={{ fontSize: "12px" }}>
                              {item.receivedQty || 0}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </div>

            <MessageTimeStamp>
              {moment.unix(c.timeStamp).format("MMM DD,YYYY")}
            </MessageTimeStamp>
          </StyledMessage>
        </MessageBody>
      </MessageRow>
    ))
  ) : (
    <NoDataFound>No Check-Ins Submitted !</NoDataFound>
  );

OrderComments.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      comment: PropTypes.string,
      name: PropTypes.string,
      profileImg: PropTypes.string,
      user: PropTypes.string,
      timeStamp: PropTypes.number,
      lineItems: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          qty: PropTypes.number,
          receivedQty: PropTypes.number,
        })
      ),
    })
  ),
};

OrderComments.defaultProps = {
  comments: [],
};

export default OrderComments;
